function initInfiniteScroll() {
  const loadMoreWrapper = document.querySelector('.js-load-more-wrapper');
  const productContainer = document.querySelector('.js-collection-results');

  if (!loadMoreWrapper || !productContainer) return;

  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting && !loadMoreWrapper.classList.contains('loading')) {
        loadMoreWrapper.classList.add('loading');

        const url = loadMoreWrapper.dataset.url;
        fetch(url)
          .then(response => response.text())
          .then(html => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');

            const newProducts = doc.querySelectorAll('.js-collection-results > *');
            newProducts.forEach(el => productContainer.appendChild(el));

            const nextWrapper = doc.querySelector('.js-load-more-wrapper');
            if (nextWrapper) {
              loadMoreWrapper.dataset.url = nextWrapper.dataset.url;
              loadMoreWrapper.classList.remove('loading');
            } else {
              loadMoreWrapper.remove();
            }

            if (typeof initializeObservers === 'function') initializeObservers();

            if (typeof _swat !== 'undefined' && typeof _swat.initializeActionButtons === 'function') {
              _swat.initializeActionButtons('body');
            }
          });
      }
    });
  }, {
    rootMargin: '200px',
  });

  observer.observe(loadMoreWrapper);
}

document.addEventListener('DOMContentLoaded', initInfiniteScroll);